<template>
  <div class="navbar-dropdown">
    <!-- Select button -->
    <navbar-button class="select-button">
      {{ channelName }}
    </navbar-button>

    <!-- Dropdown list -->
    <navbar-select
      class="navbar-menu"
      :options="channels"
      :selected-id="currentChannelId"
      default-item="No Stream"
      @itemSelected="switchChannel"
    >
      <template v-slot:item="channel">
        {{ channel.data.channel_name }}
      </template>
    </navbar-select>
  </div>
</template>

<script>
import NavbarButton from "@/components/navbar/NavbarButton.vue";
import NavbarSelect from "@/components/navbar/NavbarSelect.vue";

// @group Navbar
// Dropdown channel select
export default {
  name: "NavbarChannelsDropdown",
  components: {
    NavbarButton,
    NavbarSelect
  },
  model: {
    prop: "currentChannelId",
    event: "channelSelected"
  },
  props: {
    /** channels list */
    channels: {
      type: Array,
      required: true
    },
    /** selected channel ID */
    currentChannelId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    // @vuese
    // Current channel name in visible form
    channelName() {
      for (const idx in this.channels) {
        const channel = this.channels[idx];
        if (channel.id == this.currentChannelId) {

          return channel.channel_name;
        }

      }
      return "Select Stream";
    }
  },
  methods: {
    // @vuese
    // Select channel
    // @arg id - new channel id
    switchChannel(id) {
      this.$emit("channelSelected", id);
    }
  }
};
</script>

<style scoped>
.navbar-dropdown {
  color: white;
  font-size: 13px;
  font-family: "Arial";
}

.navbar-dropdown .navbar-menu {
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  display: none;

  text-align: start;
}

.select-button {
  box-sizing: border-box;
}

/** Desktop */
@media only screen and (min-width: 992px) {
  .navbar-dropdown .navbar-menu {
    position: absolute;
    z-index: var(--navbar-dropdown-z);
    width: 150px;
    box-sizing: border-box;
  }
  .navbar-dropdown:hover .navbar-menu {
    display: block;
  }
}

/** Mobile */
@media only screen and (max-width: 991px) {
  .navbar-dropdown {
    display: flex;
    flex-direction: column;
  }
  .navbar-dropdown .navbar-menu {
    width: 100%;
    display: none;
  }
  .navbar-dropdown:hover .navbar-menu {
    display: flex;
    flex-direction: column;
  }
}
</style>
